import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useSession } from '../../contexts/SessionContext';

const OAuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useSession();

  useEffect(() => {
    const token = searchParams.get('token');
    const provider = searchParams.get('provider');
    
    if (token && provider === 'google') {
      // Use SessionContext login method to immediately update authentication state
      login(token);
      navigate('/dashboard');
    } else {
      // Redirect to login with error
      navigate('/login?error=oauth_failed');
    }
  }, [navigate, searchParams, login]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body1">
        Completing sign-in...
      </Typography>
    </Box>
  );
};

export default OAuthCallback; 